<template>
    <div>
        <template v-if="!ClientContractID || !ClientContractID.id">
            <div class="d-flex align-items-center justify-content-center" style="height: calc(100vh - 57px);">
                <h2 class="text-danger">Please choose a contract to load the cases.</h2>
            </div>
        </template>
        <div class="animated fadeIn bgV2" v-else>
            <b-row>
                <b-col md="12">
                    <gofix-tab
                            classTabContent="pl-12 pr-12"
                            class="mt-3"
                            :data="tabData"
                            activeKey="closed_case">
                        <template slot="gofixTab:closed_case">
                            <CaseListing :case_status="'Closed'" v-if="ClientContractID.case_setting_module == 'Generic'"/>
                            <CaseHotButtonListing :case_status="'Closed'" v-if="ClientContractID.case_setting_module == 'Hot-Button'"/>
                        </template>
                    </gofix-tab>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    const CaseListing = () => import("./CaseListing")
    const CaseHotButtonListing = () => import("../caseHotButton/CaseListing.vue")
    import { mapGetters } from 'vuex';
    export default {
        name: 'joblist-all',
        components: {
            CaseListing,
            CaseHotButtonListing
        },
        data() {
            return{
                tabData:[
                    {
                        key: "opening_case",
                        title: "Open",
                        active: false,
                        link: `/v2/case/opening`
                    },
                    {
                        key: "closed_case",
                        title: "Closed",
                        active: false,
                        link: `/v2/case/closed`
                    },
                    {
                        key: "all_jobs",
                        title: "ALL",
                        active: true,
                        link: `/v2/case`
                    },
                ]
            }
        },

        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        async created() {


        },
        watch: {

        },
        methods: {

        }
    }
</script>
